export const totalPages = (totalRows: number, limit: number) => {
  return Math.ceil(totalRows / limit);
};

export const errorMessageAutoCapitalize = (field: string) => {
  const result = [];
  const srtArr = field.split('');
  for (let i = 0; i < srtArr.length; i++) {
    if (srtArr[i] === srtArr[i].toUpperCase()) {
      result.push(' ');
      result.push(srtArr[i]);
    } else {
      result.push(srtArr[i]);
    }
  }
  return result[0].toUpperCase() + result.slice(1).join('');
};

export const handlingNullData = (data: any) => {
  return data !== null &&
    data !== '00000000-0000-0000-0000-000000000000' &&
    data !== ''
    ? data
    : '-';
};

export const handlingMoreCharactor = (word: string, NoOfChar: number) => {
  return word.length < NoOfChar ? word : word.substring(0, NoOfChar) + '...';
};

export const formatDate = (inputDate: string) => {
  if (!inputDate) {
    return null;
  }
  const date = new Date(inputDate);
  const isValidDate = !isNaN(date.getTime());

  return isValidDate
    ? date
        .toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        })
        .toUpperCase()
    : null;
};
